import HeroSection from "./Pages/HeroSection";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivacyPolicy from "./Pages/Privacy Policy/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions/TermsAndConditions";
import FooterSection from "./Components/Footersection";

function App() {
  return (
    <div>
      <Routes>
          <Route
            path="/"
            element={<HeroSection />}
          />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy />}
          />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="*"
            element={<Navigate to="/" />}
          />
        </Routes>

        <FooterSection />
     
     
    </div>
  );
}

export default App;